import { Badge } from '@usealloy/component-library';
import { StyledEvaluationSetTagNodeIndicator } from 'flow/editor/components/Graph/nodes/BaseNode/BaseNode.styles';
import styled from 'styled-components';

const StyledBadge = styled(Badge)`
  gap: var(--cl-space-2);
`;

export default function OutcomeContributingBadge() {
  return (
    <StyledBadge>
      <StyledEvaluationSetTagNodeIndicator />
      Outcome Contributing
    </StyledBadge>
  );
}
